<template>
  <!-- v-if="isGenTrackingCode" -->
  <div class="card shadow m-3 position-fixed right-0 top-0" style="z-index:1">
    <div class="card-body d-flex align-items-center">
      <div :class="{ 'rotate': !complete }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width:50px; height:50px;">
        <i class="fa-solid fa-hourglass-half fa-2x"></i>
      </div>

      <div data-test="progress-bar-move-to-ready-to-ship">
        <div class="progress rounded-round mb-2" style="height:12px">
          <div class="progress-bar bg-primary rounded-round" :style="`width:${progressBarWidth}%;`">
          </div>
        </div>
        <div>
          <!-- กำลังสร้างหมายเลขแทรคกิ้ง 4 รายการจากทั้งหมด 50 รายการ -->
          {{ $t('Moving to ready to ship {countShipment} shipment from {shipmentTotal} shipments') | replaceText(countMoveToReadyToShip, shipmentTotal) }}
        </div>

        <div v-if="showLogError">
          <a href="#collapse-icon" class="collapsed font-size-sm text-default" data-toggle="collapse">
            <span class="text-muted">{{ $t('Activity Logs Shipment') }}</span> <i
              class="fa-regular fa-triangle-exclamation text-danger"></i>
          </a>
        </div>
      </div>
      <button :class="{ 'text-muted': !closeModal }" @click="moveToReadyToShipSuccess()" type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2">
        <span>×</span>
      </button>
    </div>

    <div v-if="showLogError" style="max-width: 320px;">
      <div class="collapse" id="collapse-icon">
        <div v-if="errorList" class="card-body border-left-warning border-left-2 pl-0 pt-0"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;">
          <ul class="list mb-0">
            <li v-for="(list, i) in errorList" :key="'list' + i" class="font-size-sm mb-2"
              :class="{ 'text-danger': !list.status }">
              <span v-if="list.status">({{ list.orderNumber }}) {{ list.message }}</span>
              <span v-else>({{ list.orderNumber }}) {{ list.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.Pusher = require('pusher-js');

import WebSocket from "isomorphic-ws";
import Api from "@/services/endpoint/tenant.service";
import {
  toreadytoship
} from "./api/axios";
import Cookies from "js-cookie";

export default {
  data() {
    const vm = this;
    return {
      closeModal: false,
      errorList: [],
      shipmentTotal: 0,
      countMoveToReadyToShip: 0,
      showLogError: false,
      websocket: null,
      payload: {},
      inprogress: {
        toReadyToShip: false
      },
      tenant: JSON.parse(Cookies.get('tenant')),
      user: JSON.parse(Cookies.get('user')),
    }
  },
  computed: {
    checkListReady() {
      return this.$store.state.shipment.checkListReady;
    },
    progressBarWidth() {
      return this.countMoveToReadyToShip * 100 / this.shipmentTotal;
    },
    complete() {
      return this.errorList.length == this.shipmentTotal;
    }
  },
  methods: {
    moveToReadyToShipSuccess() {
      if (!this.closeModal) return;
      this.$store.dispatch("shipment/updateShipmentDataTable", true);
      this.$store.dispatch("shipment/isModalMoveToReadyToShip", {isShowProgress: false});
    },
    async moveToReadyToShip() {
      const isModalMoveToReadyToShip = this.$store.state.shipment.isModalMoveToReadyToShip;
      this.shipmentTotal = isModalMoveToReadyToShip.payload.shipment_id.length
      this.payload = isModalMoveToReadyToShip.payload
      let vm = this;

      // Open Websocket
      this.openChannelWebsocketReadyToShip();

      if (this.$storeIndex.isset(() => this.payload.to_qms) && this.payload.to_qms == true) {
        await Api.ShipmentV2.moveReadyToShipWithStocks({ shipments: this.payload.shipments }).then((response) => {
          console.log(response, 'response moveReadyToShipWithStocks')
        }).catch((error) => {
          console.log('moveReadyToShipWithStocks error', error)
          vm.closeModal = true;
          vm.moveToReadyToShipSuccess();
          vm.$toastr.e(
            vm.$t("Something went wrong. Please try again."),
            "<span class='icon-blocked'></span>" + vm.$t("Error")
          );
        })
      } else {
        return toreadytoship(this.payload).then((response) => {
          if (response.errors) {
            let shipmentIds = [];
            for (let dataE of response.errors) {
              if (!vm.showLogError) {
                vm.showLogError = true;
              }

              vm.countMoveToReadyToShip += 1;

              let shipmentList = this.$store.state.shipment.shipmentDataList.data;
              let shipment = shipmentList.find((shipment) => {
                return shipment.id == dataE.shipment_id
              })

              vm.errorList.unshift({
                'status': false,
                'shipmentId': dataE.shipment_id,
                'message': dataE.errors,
                'orderNumber': shipment.shipment_package[0].sales_order[0].order_number,
              });

              shipmentIds.push(dataE.shipment_id);
            }

            vm.closeModal = true;

            vm.$store.dispatch("shipment/setInProgressShipment", {
              shipmentIds: shipmentIds,
              status: "cross",
            });
          }
        }).catch((error) => {
          console.log('movetoreadytoship error', error)
        })
      }
    },
    async openChannelWebsocketReadyToShip() {
      let vm = this;
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      // Open websocket

      let userId = this.user.id;
      let totalMoveReadyToShip = this.payload.shipment_id;
      const tenant = this.tenant;


      if (this.$storeIndex.isset(() => this.$store.state.shipment.shipmentDataList.data)) {
        if (localStorage.getItem('isCypress')) {
          let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
          if (dataWebsocket) {
            dataWebsocket.forEach(data => {
              let dataOnmessage = JSON.parse(JSON.stringify(data)) 
              vm.websocketOnMessage(dataOnmessage ,userId, tenant , totalMoveReadyToShip);
            }); 
          }
        } else {
          ws.onopen = function open() {
            if (!vm.inprogress.toReadyToShip) {
              if (vm.$storeIndex.isset(() => totalMoveReadyToShip)) {
                vm.$store.dispatch("shipment/setInProgressShipment", {
                  shipmentIds: totalMoveReadyToShip,
                  status: true,
                });
                vm.inprogress.toReadyToShip = true;
              }
            }
            ws.send(JSON.stringify({
            "data": {
              "clientUid": `request.move.ready.to.ship${userId}${tenant.id}`
            },
            "event": "subscribe"
            }));
            ws.onmessage = function incoming(message) {
              let dataOnmessage = JSON.parse(message.data)
              vm.websocketOnMessage(dataOnmessage , userId ,tenant , totalMoveReadyToShip);
            }
          };
        }
      }
    },

    websocketOnMessage (data , userId ,tenant , totalMoveReadyToShip) {
      let vm = this;
      if (data.data.clientUid == `request.move.ready.to.ship${userId}${tenant.id}` && data.event == `request.move.ready.to.ship`) {
              let payload = data.data;
              if (payload.status) {
                vm.countMoveToReadyToShip += 1;
                vm.$store.dispatch("shipment/setInProgressShipment", {
                  shipmentIds: [payload.shipmentId],
                  status: "checkmark",
                });
              } else {
                if(!vm.showLogError) {
                  vm.showLogError = true;
                }

                let shipment = vm.$store.state.shipment.shipmentDataList.data.find((shipment) => {
                  return shipment.id == payload.shipmentId
                })

                vm.errorList.unshift({
                  'status': false,
                  'shipmentId': payload.shipmentId,
                  'message': payload.message,
                  'orderNumber': shipment.shipment_package[0].sales_order[0].order_number,
                });

                vm.countMoveToReadyToShip += 1;

                vm.$store.dispatch("shipment/setInProgressShipment", {
                  shipmentIds: [payload.shipmentId],
                  status: "cross",
                });
              }
              if (vm.countMoveToReadyToShip == totalMoveReadyToShip.length) {
                vm.closeModal = true;
                if (!vm.showLogError) {
                  setTimeout(() => {
                    vm.$swal.fire({
                      title: vm.$t('Move to Ready To Ship'),
                      icon: 'success',
                      html: vm.$t('move from packing to readytoship success'),
                      confirmButtonText: vm.$t('OK'),
                      buttonsStyling: false,
                      customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-light'
                      },
                      focusConfirm: false,
                      allowOutsideClick: false,
                      allowEscapeKey: false
                    }).then((result) => {
                      if (result.isConfirmed) {
                        vm.$store.dispatch("shipment/updateShipmentDataTable", true);
                        vm.$store.dispatch("shipment/isModalMoveToReadyToShip", false);
                        vm.websocket.close();
                      }
                    });
                  }, 1000);
                }
              }
            }
    }
  },
  mounted() {
    this.moveToReadyToShip();
  },
  beforeDestroy() {

  },
  filters: {
    replaceText: function (text, countShipment, shipmentTotal) {
      text = text.replace('{shipmentTotal}', shipmentTotal);
      text = text.replace('{countShipment}', countShipment);
      return text;
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ModalMoveToReadyToShip.vue